import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import Table, { Column } from 'Components/Table';

// Material UI
import {
    Typography,
    Grid
} from '@mui/material';
// Components
import Modal, { ModalBody } from 'Components/Modal';
// Actions
import {
    searchTransactions,
    openDriverTransaction,
    clearRedux
} from "Redux/actions";


const ResumeTransaction = (props) => {
    // Intl
    const { messages } = useIntl();

    //props 
    const { callback, idTransaction } = props;

    // Hooks
    const dispatch = useDispatch();

    // State local
    const {
        transactions,
        openTransaction,
        loading
    } = useSelector((state) => state.driverCreateEditSliceRedux);

    const [dataResume, setDataResume] = useState([]);

    useEffect(() => {
        if (transactions && openTransaction && transactions?.items?.length > 0) {

            let resume = [];
            transactions?.items?.forEach((data) => {

                let dataDriver = JSON.parse(JSON.parse(data.Data));

                resume.push({
                    Driver: dataDriver?.Driver,
                    Email: dataDriver?.Email,
                    Group: dataDriver?.Group,
                    Tag: dataDriver?.Tag,
                    Status: data.State,
                    Error: data.ErrorMessage
                });
            });

            setDataResume([...dataResume, ...resume]);

            if (transactions?.nextToken) {
                dispatch(searchTransactions({ transactionId: idTransaction, nextToken: transactions?.nextToken }));
            }
        }
    }, [transactions, openTransaction]);

    useEffect(() => {
        dispatch(searchTransactions({ transactionId: idTransaction, nextToken: '' }));
    }, []);

    const handleClose = useCallback(() => {
        dispatch(openDriverTransaction(false));
        dispatch(clearRedux("SETTINGS_DRIVER", {
            openTransaction: false,
            loading: false,
            transactions: [],
            openImport: false,
            urlFileCsv: null,
            csvFile: null
        }));
        dispatch(clearRedux("CATALOG_REDUX", { migrationPushNotification: {} }))

        callback();
    });



    return (
        <Fragment>
            <Modal
                title={messages["settingsDriver_resume"]}
                open={openTransaction}
                size="small"
                handleClose={() => handleClose()}
                position="right"
                loading={loading}
            >
                <ModalBody style={{ padding: 25 }}>
                    <Table
                        data={dataResume}
                        loading={loading}
                        heightAuto
                        hidePagination
                        hideSelectableCheckbox
                    >
                        <Column label={messages['settingsDriver_driver']} field="Driver" style={{ fontSize: 11 }} />
                        <Column label={messages['settingsDriver_email']} field="Email" style={{ fontSize: 11 }} />
                        <Column label={messages['settingsDriver_group']} field="Tag" style={{ fontSize: 11 }} />
                        <Column label={messages['settingsDriver_status']} field="Status" style={{ fontSize: 11 }} />
                        <Column label={messages['settingsDriver_error']} style={{ fontSize: 11 }} field="Error" />
                    </Table>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}

export default ResumeTransaction;